"use client";
import { useId, useState } from "react";
import { useTranslations } from "@zapier/i18n";
import { useSplitTreatments, useUserAccountRole } from "@zapier/client";

import FolderTreeItem from "../../folders/FolderTree/V2/FolderTreeItem/FolderTreeItem";
import MemberFolderLookup from "./MemberFolderLookup";
import styles from "./OtherMembersPersonalFoldersAccordion.module.css";

function OtherMembersPersonalFoldersAccordion() {
  const t = useTranslations("other-members-personal-folders");
  const { isAccountOwner, isSuperAdmin } = useUserAccountRole();
  const { isSuperAdminPersonalFoldersEnabled } = useSplitTreatments();
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  if (
    !isSuperAdminPersonalFoldersEnabled ||
    (!isAccountOwner && !isSuperAdmin)
  ) {
    return null;
  }

  return (
    <div className={styles.root}>
      {/* Reuses FolderTreeItem's own accordion-header mode so this matches
          "My folders"/"Folders shared with me" exactly (same text size/weight,
          same rotating caret) instead of the generic design-system Accordion,
          which renders as its own visually distinct, bordered section. */}
      <FolderTreeItem
        text={t("labels.title")}
        isAccordionHeader
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-owns={contentId}
      />
      {isOpen && (
        <div id={contentId} className={styles.content}>
          <MemberFolderLookup />
        </div>
      )}
    </div>
  );
}

export default OtherMembersPersonalFoldersAccordion;
